import React from "react";
import { useHistory } from "react-router-dom";
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { connect } from "react-redux";
import CIcon from "@coreui/icons-react";

const TheHeaderDropdownTasks = (props) => {
  const history = useHistory();
  const handleSignout = async () => {
    await window.sessionStorage.removeItem("userToken");
    await window.sessionStorage.removeItem("isClient");
    await window.sessionStorage.removeItem("isHandler");
    props.dispatch({ type: "SIGNOUT" });
    history.push("/");
  };

  return (
    <CDropdown inNav className="c-header-nav-item mx-2">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <CIcon name="cil-settings" />
      </CDropdownToggle>
      <CDropdownMenu placement="bottom-end" className="pt-0">
        <CDropdownItem
          className="text-center border-top"
          onClick={() => {
            handleSignout();
          }}
        >
          <strong>Sign Out</strong>
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  );
};
function mapStateToProps(state) {
  return {
    ...state,
    userToken: state.userTokenReducer.userToken,
  };
}

export default connect(mapStateToProps)(TheHeaderDropdownTasks);
